import { 
    Alert 
} from "@mantine/core"
import { 
    IconAlertCircle
} from '@tabler/icons-react';

type ErrorAlertProps = {
    displayed: boolean;
    title: string;
    text?: string;
}

export const ErrorAlert = ({ displayed = false, title, text}: ErrorAlertProps) => {

    return (
        <>
            { 
                displayed ?
                    <Alert icon={<IconAlertCircle size="1rem" />} title={title} color="red">
                        {text}
                    </Alert>
                : <></>
            }
        </>
    )
}